import React from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";
import SimpleModal from "@src/Components/Common/SimpleModal/SimpleModal";
import { Grid, IconButton, TextField } from "@material-ui/core";
import { Values } from "@src/Tools/Values";
import {
  STButton,
  STButtonText,
  STGridRoot,
  STGridItem,
  STGrid,
  STCheckbox,
  STText,
  STTypography,
  STGridButtons,
  STNoItemsText,
} from "./styles";
import RestoreIcon from "@material-ui/icons/Restore";
import { IManagementStore } from "@src/Stores/Management/types";
import { STButtonMargin } from "@src/Components/Ui/STButtonMargin";
import ClearIcon from "@material-ui/icons/Clear";

interface IProps {
  management?: IManagementStore;
}

@inject("management")
@observer
export default class RestoreDatabaseBackup extends React.Component<IProps> {
  @observable isOpened: boolean = false;
  @observable backupFileNames: string[] = [];
  @observable selectedFileName: string;

  handleOpen = async () => {
    this.backupFileNames = await this.props.management.getAllBackupFileNames();
    this.selectedFileName = "";
    this.isOpened = true;
  };

  handleClose = () => {
    this.isOpened = false;
  };

  handleChecked = (fileName: string) => {
    if (this.selectedFileName === fileName) {
      this.selectedFileName = "";
      return;
    }
    this.selectedFileName = fileName;
  };

  handleApplyChanges = () => {
    this.props.management.restoreDatabaseBackup(this.selectedFileName);
    this.isOpened = false;
  };

  handleFileOpen = (e: any) => {
    const fileNode: any = document.querySelector("#fileInput");
    fileNode.click();
  };

  handleFileChange = async (event: any) => {
    event.persist();
    var formData = new FormData();
    formData.append("file", event.target.files[0]);
    await this.props.management.uploadDatabaseBackup(formData);
  };

  handleDownloadDatabaseBackup = async (backupFileName: string) => {
    await this.props.management.downloadDatabaseBackup(backupFileName);
  };

  render() {
    return (
      <React.Fragment>
        <div>
          <STButton variant="contained" onClick={this.handleOpen}>
            <RestoreIcon />
            <STButtonText>{Values.getLocalizationValue("restoreDatabaseBackup")}</STButtonText>
          </STButton>
        </div>

        <SimpleModal width={500} isOpened={this.isOpened} onClose={this.handleClose}>
          <STGridRoot container direction="column" justify="space-between" alignItems="center">
            <Grid container alignItems="center">
              <STTypography>{Values.getLocalizationValue("selectBackup")}</STTypography>
              <IconButton style={{ marginLeft: "auto" }} onClick={this.handleClose}>
                <ClearIcon />
              </IconButton>
            </Grid>

            <STGrid container>
              {this.backupFileNames.length === 0 && (
                <STNoItemsText>{Values.getLocalizationValue("thereAreNoItems")}</STNoItemsText>
              )}
              {this.backupFileNames.map((fileName: string, index: number) => (
                <STGridItem item key={index}>
                  <STCheckbox
                    color="primary"
                    checked={this.selectedFileName === fileName}
                    onChange={() => this.handleChecked(fileName)}
                  />
                  <STText onClick={() => this.handleDownloadDatabaseBackup(fileName)}>{fileName}</STText>
                </STGridItem>
              ))}
            </STGrid>

            <STGridButtons container>
              <STButtonMargin style={{ textTransform: "none" }} onClick={this.handleFileOpen} variant="contained">
                {Values.getLocalizationValue("uploadDatabase")}
              </STButtonMargin>
              <TextField
                type="file"
                fullWidth
                onChange={this.handleFileChange}
                id="fileInput"
                style={{ display: "none" }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <STButtonMargin
                style={{ marginLeft: "auto", textTransform: "none" }}
                onClick={this.handleApplyChanges}
                variant="contained"
                color="primary"
                disabled={!this.selectedFileName}
              >
                {Values.getLocalizationValue("applyChanges")}
              </STButtonMargin>
            </STGridButtons>
          </STGridRoot>
        </SimpleModal>
      </React.Fragment>
    );
  }
}
